'use strict';

angular.module('sharecrf.loading', [
    'inetsys.modal',
    'ui.router',
]);
